import { batch } from './batch.reducer';
import { Inventory } from './../invetory.reducer';
import { ActivatedRoute, Router } from '@angular/router';
import { FETCH_ALL_DESTINATION_REQUESTED, FETCH_ALL_DESTINATION_SUCCEEDED } from './../../destination/destination.action';
import { NotificationService } from './../../../common/services/notification/notification.service';
import { API_CALL_ERROR } from './../../../store/action';
import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put, select, takeLatest } from 'redux-saga/effects';
import {
  SAVE_PRODUCT_LOCATION,
  UPDATE_MULTI_PRODUCT_LOCATION_REQUESTED,
  SAVE_PRODUCT_LOCATION_SUCCEEDED,
  UPDATE_MULTI_PRODUCT_LOCATION_SUCCEEDED,
  DETECT_TYPE_OF_CODE_REQUESTED,
  DETECT_TYPE_OF_CODE_SUCCESSED,
  MAP_DESTINATION_TO_PRODUCT,
  UPDATE_PRODUCT_DESTINATION
  // MAP_DESTINATION_TO_INVENTORY
} from './batch.actions';
import * as _ from 'lodash';
import { FETCH_LOCATIONS_REQUESTED } from '../../location/list/list.action';
import { PreloaderService } from '../../../common/services/preloader/preloader.service';

function* fetchDestinations(action) {
  yield put({ type: FETCH_ALL_DESTINATION_REQUESTED, com: 'BULK_UPDATE_COMPONENT' });
}

function* watchFetchInventoriesSuccessed() {
  yield takeLatest(DETECT_TYPE_OF_CODE_SUCCESSED, fetchDestinations);
}

function* assignProductLocationWithDestination(action) {
  if (action.com === 'BULK_UPDATE_COMPONENT') {
    yield put({ type: MAP_DESTINATION_TO_PRODUCT, data: action.data });
  }
}

function* watchFetchAllDestinationSuccessed() {
  yield takeEvery(FETCH_ALL_DESTINATION_SUCCEEDED, assignProductLocationWithDestination);
}

function* saveProductLocation(action) {
  try {
    AppInjector.get(PreloaderService).show();
    let params = _.pick(action.data, ['product_sku', 'destination_id', 'location_id']);
    let result = yield AppInjector.get(ApiService)
      .event.create(params)
      .toPromise();
    AppInjector.get(PreloaderService).hide();
    if (!_.isUndefined(action.redirect)) {
      AppInjector.get(Router).navigateByUrl(action.redirect);
    } else {
      yield put({ type: SAVE_PRODUCT_LOCATION_SUCCEEDED, data: result, com: action.com });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSaveProductLocation() {
  yield takeEvery(SAVE_PRODUCT_LOCATION, saveProductLocation);
}

function* saveProductLocationSuccessed(action) {
  if (action.com === 'BULK_UPDATE') {
    AppInjector.get(NotificationService).show('success', 'Product location is updated', 3000);
  }
}

function* watchSaveProductLocationSuccessed() {
  yield takeEvery(SAVE_PRODUCT_LOCATION, saveProductLocationSuccessed);
}

function* updateMultiProductLocation(action) {
  try {
    let params = { events: action.data };
    AppInjector.get(PreloaderService).show();
    let result = yield AppInjector.get(ApiService)
      .event.bulk(params)
      .toPromise();
    AppInjector.get(PreloaderService).hide();
    AppInjector.get(NotificationService).show('success', 'Update product location success', 5000);
    if (_.isUndefined(action.com)) {
      yield put({ type: UPDATE_MULTI_PRODUCT_LOCATION_SUCCEEDED, data: result });
    } else {
      yield put({ type: UPDATE_MULTI_PRODUCT_LOCATION_SUCCEEDED, data: result, com: action.com });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateMultiProductLocationRequested() {
  yield takeEvery(UPDATE_MULTI_PRODUCT_LOCATION_REQUESTED, updateMultiProductLocation);
}

function* fetchNewProductLocationData(action) {
  try {
    if (!_.isUndefined(action.com) && action.com === 'BULK_UPDATE') {
      const items = yield select(state => (state as any).Inventory.batch.codes);
      yield put({ type: DETECT_TYPE_OF_CODE_REQUESTED, data: _.map(items, i => i.code) });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateMultiProductLocationSuccessed() {
  yield takeEvery(UPDATE_MULTI_PRODUCT_LOCATION_SUCCEEDED, fetchNewProductLocationData);
}

function* detectTypeOfCode(action) {
  try {
    const locations = yield AppInjector.get(ApiService)
    .location.list({ codes: action.data })
    .toPromise();
    yield put({
      type: DETECT_TYPE_OF_CODE_SUCCESSED,
      kind: 'location',
      data: locations
    });
    const products = yield AppInjector.get(ApiService)
      .product.list({ skus: action.data })
      .toPromise();
    yield put({
      type: DETECT_TYPE_OF_CODE_SUCCESSED,
      kind: 'product',
      data: products
    });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDetectTypeOfCode() {
  yield takeEvery(DETECT_TYPE_OF_CODE_REQUESTED, detectTypeOfCode);
}

export default [
  watchFetchAllDestinationSuccessed,
  watchSaveProductLocation,
  watchFetchInventoriesSuccessed,
  watchUpdateMultiProductLocationRequested,
  watchUpdateMultiProductLocationSuccessed,
  watchSaveProductLocationSuccessed,
  watchDetectTypeOfCode
];
